module.exports = __webpack_public_path__ + "img/bgtop3.7f8cefc9.jpg";